import { MessageSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { FaWhatsapp } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import { useCallback } from 'react';

const CONTACT_CONFIG = {
  MAIL: {
    link: 'mailto:info@homeperly.it',
    message: 'Ti stiamo reindirizzando al tuo client email',
  },
  WA: {
    link: 'https://wa.me/message/IYZYW57O43KNP1',
    message: 'Ti stiamo reindirizzando a WhatsApp',
  },
};
export const ContactButton = () => {
  const location = useLocation();

  const handleContact = useCallback((contact: keyof typeof CONTACT_CONFIG) => {
    const { link, message } = CONTACT_CONFIG[contact];
    window.location.href = link;
    toast.success(message);
  }, []);

  // Only show on home page
  if (location.pathname !== '/') {
    return null;
  }
  return (
    <div className="fixed bottom-16 md:bottom-6 right-4 md:right-6 flex flex-col gap-2 md:gap-3 z-50">
      <Button
        onClick={() => handleContact('WA')}
        className="rounded-full w-12 h-12 md:w-14 md:h-14 shadow-lg hover:shadow-xl transition-shadow bg-primary hover:bg-primary/90 flex items-center justify-center"
      >
        <FaWhatsapp className="w-6 h-6 md:w-6 md:h-6" />
      </Button>
      <Button
        onClick={() => handleContact('MAIL')}
        className="rounded-full w-12 h-12 md:w-14 md:h-14 shadow-lg hover:shadow-xl transition-shadow bg-primary hover:bg-primary/90 flex items-center justify-center"
      >
        <MessageSquare className="w-6 h-6 md:w-6 md:h-6" />
      </Button>
    </div>
  );
};
